import React, { useState } from "react";
import { Box, Typography, Stack, Avatar, Divider } from "@mui/material";
import { Images } from "../../assets/common";
import { isEmpty, kFormatter } from "../../constants/function";
import TopListPopup from "../TopListPopup";

export default function PlaylistStaticsCard({
  image,
  title,
  value,
  color,
  isArray,
  isTip,
  border,
  tip,
  statType,
}) {
  const [open, setOpen] = useState(false);
  const isSocial = isArray || isTip;

  // ── Legacy mode (no statType) ──
  if (!statType) {
    return (
      <Stack
        spacing={1}
        sx={{
          background: color,
          minHeight: "63px",
          border: border ? border : 0,
          borderRadius: "5px",
          padding: "16px",
        }}
        className="__responsive_playlist_statics_card"
      >
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" gap="5px" alignItems="center">
            <img style={{ width: "22px" }} src={image} alt={title} />
            <Typography className="fs-20">{title}</Typography>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between" gap="5px">
          {isTip ? (
            <Stack direction="row" justifyContent="end" alignItems="center" sx={{ width: "100%", cursor: "pointer" }} onClick={() => setOpen(true)}>
              <img style={{ transform: "rotate(180deg)", marginLeft: "10px" }} src={Images.back} alt="go" />
            </Stack>
          ) : isArray ? (
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: "100%", cursor: "pointer" }} onClick={() => setOpen(true)}>
              <Box className="ml_auto" sx={{ display: "flex", flexDirection: "row-reverse" }}>
                {value && value.map((m, index) => (
                  <Avatar sx={{ marginRight: index > 0 ? "-20px" : 0 }} key={index} src={m["profileImg"] ? m["profileImg"]["filePath"] : null} />
                ))}
              </Box>
              {value && value.length > 0 && (
                <img style={{ transform: "rotate(180deg)", marginLeft: "10px" }} src={Images.back} alt="go" />
              )}
            </Stack>
          ) : (
            <Typography className="fs-30 ml_auto fw-b">
              {isEmpty(value) ? 0 : kFormatter(value)}
            </Typography>
          )}
        </Stack>
        {open && (
          <TopListPopup isTip={isTip} data={value} isArray={isArray} image={isTip ? Images.music_play : Images.handHolding} open={open} handleClose={() => setOpen(false)} />
        )}
      </Stack>
    );
  }

  // ── Hero card (Total Listens) ──
  if (statType === "listens") {
    return (
      <div className="gs-hero-card">
        <div className="gs-ring gs-ring--inner" />
        <div className="gs-ring gs-ring--outer" />
        <div className="gs-ring gs-ring--glow" />
        <div className="gs-hero-label">{title}</div>
        <div className="gs-hero-value">
          {isEmpty(value) ? "0" : kFormatter(value)}
        </div>
        <div className="gs-hero-border-glow" />
      </div>
    );
  }

  // ── Social card (Top Listeners / Top Tippers) ──
  if (isSocial) {
    const hasData = value && value.length > 0;
    const previewAvatars = hasData ? value.slice(0, 5) : [];

    return (
      <div className="gs-social-card" onClick={() => setOpen(true)}>
        <div className="gs-social-header">
          <span className="gs-social-label">{title}</span>
          <img className="gs-social-icon" src={image} alt="" />
        </div>
        {previewAvatars.length > 0 && (
          <div className="gs-avatar-cluster">
            {previewAvatars.map((m, i) => (
              <Avatar
                key={i}
                src={m["profileImg"] ? m["profileImg"]["filePath"] : null}
              />
            ))}
          </div>
        )}
        <div className="gs-view-all">
          <span>{hasData ? "View Leaderboard" : "No data yet"}</span>
          {hasData && (
            <img className="gs-view-arrow" src={Images.back} alt="" />
          )}
        </div>
        {open && (
          <TopListPopup
            isTip={isTip}
            data={value}
            isArray={isArray}
            image={isTip ? Images.music_play : Images.handHolding}
            open={open}
            handleClose={() => setOpen(false)}
          />
        )}
      </div>
    );
  }

  // ── Badge card (First Listens, First Listings, Top Playlist) ──
  return (
    <div className={`gs-stat-badge gs-stat-badge--${statType}`}>
      <div className="gs-orb" />
      <div className="gs-badge-content">
        <div className="gs-badge-value">
          {isEmpty(value) ? "0" : kFormatter(value)}
        </div>
        <div className="gs-badge-label">{title}</div>
      </div>
    </div>
  );
}
